module.exports = __webpack_public_path__ + "img/search-white.d3d32cb8.svg";